import {createSlice} from '@reduxjs/toolkit'
import { currentUser } from '@/store/current-user/action';

const initialState = {
  state: null,
  loading: true,
  error: ''
} as BaseState<Users>

const slice = createSlice({
  name: 'userInfoSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(currentUser.pending, (state) => ({
      ...state,
      loading: true,
      error: null
    }))
    builder.addCase(currentUser.fulfilled, (state, action) => ({
      state: action.payload,
      loading: false,
      error: null
    }))
    builder.addCase(currentUser.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get user data'
    }))
  }
})

export const authActions = slice.actions

export default slice
